/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2024
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

// client-extensions/result-enriching-response-observer
 
define([
  "underscore",
  "backbone"
], function(
  _,
  Backbone
) {

  var ModelResponseObserver = function(model, modelOptions, observerOptions) {
    this.model = model;
    this.modelOptions = modelOptions || {};
    this.observerOptions = observerOptions || {};

    this.modelActionPromises = [];

    this.initialize.apply(this, arguments);
  }

  _.extend(ModelResponseObserver.prototype, Backbone.Events, {

    initialize : function() { },

    resetModel: function(attributes, options) {
      var resetOptions = this._buildModelOptions(options);
      return this._executeInOrder(function() {
        return this.model.reset(attributes, resetOptions);
      });
    },

    updateModel: function(attributes, options) {
      var updateOptions = this._buildModelOptions(options);
      return this._executeInOrder(function() {
        return this.model.update(attributes, updateOptions);
      });
    },

    _executeInOrder: function(callback) {
      var that = this;
      var actionPromises = this.modelActionPromises;

      var promise;

      if (actionPromises.length > 0) {
        promise = actionPromises[actionPromises.length - 1].then(function() {
          return callback.apply(that);
        });
      } else {
        promise = callback.apply(that);
      }

      actionPromises.push(promise);
      return promise;
    },

    onModelActionsFinished: function(callback, additionalWaitPromises) {
      additionalWaitPromises = additionalWaitPromises || [];

      var promises = []
        .concat(this.modelActionPromises)
        .concat(this.additionalWaitPromises);

      return Promise.allSettled(promises).then(function() {
        return callback();
      })
    },

    getAdditionalModelOptions: function() {
      return this.modelOptions;
    },

    _buildModelOptions: function(options) {
      return _.extend({}, options, this.getAdditionalModelOptions());
    },

    finalize: function() { },
  })

  ModelResponseObserver.extend = Backbone.Model.extend;
  return ModelResponseObserver;
})
